import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  updateHeader,
  updateImage,
} from "../../../redux/actions/addCampaigndata";
import { Add } from "@mui/icons-material";
import { Box, Button, Checkbox, FormControlLabel, Grid, MenuItem, Paper, TextField, Toolbar, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { Col, Row } from "react-bootstrap";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import StarRateIcon from '@mui/icons-material/StarRate';
import { Toastify } from "../../../services/toastify/toastifyContainer";
import DeleteIcon from "@mui/icons-material/Delete";
import ImageModal from "../../Add_Campaign/comman/Modal";
import CloseIcon from '@mui/icons-material/Close';
import ImageWithDeleteButton from "../comman/imageContainer";
import { motion } from "framer-motion";


const logoSchemas = yup.object().shape({
  file: yup
    .mixed()
    .test("fileFormat", "Unsupported file format", (value) => {
      if (!value || !value.file) {
        return true;
      }
      const file = value.file;
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const supportedFormats = ["jpeg", "jpg", "png", "gif", "bmp", "svg", "webp"];
      return supportedFormats.includes(fileExtension);
    })
    .nullable(),
  // url: yup.string(),
  link: yup.string().url("Invalid URL format"),
  image: yup.string(),
  alt: yup.string(),
  target: yup.string(),
}).notRequired();

const logoSchemaRight = yup.object().shape({
  file: yup
    .mixed()
    .test("fileFormat", "Unsupported file format", (value) => {
      if (!value || !value.file) {
        return true;
      }
      const file = value.file;
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const supportedFormats = ["jpeg", "jpg", "png", "gif", "bmp", "svg", "webp"];
      return supportedFormats.includes(fileExtension);
    })
    .nullable(),
  // url: yup.string(),
  link: yup.string().url("Invalid URL format"),
  image: yup.string(),
  alt: yup.string(),
  target: yup.string(),
}).notRequired();



const logoSchemaSEO = yup
  .mixed().nullable().test("fileFormat", "Unsupported file format", (value) => {
    // If no value or no file is provided, return true
    if (!value || !value.file) {
      return true;
    } else if (value || !value.file) {
      return true
    }

    // If a file is provided, perform file format validation
    const file = value.file;
    const fileExtension = file?.name?.split(".").pop().toLowerCase();
    const supportedFormats = ["jpeg", "jpg", "png", "gif", "bmp", "svg", "webp"];
    // Check if the file extension is supported
    return fileExtension && supportedFormats.includes(fileExtension);
  })
  .notRequired();



const navListSchema = yup
  .array()
  .of(
    yup.object().shape({
      text: yup.string(),
      link: yup.string().url("Invalid URL format"),
      target: yup.string(),
      order: yup.string().notRequired(),
    })
  )
  .notRequired();

const schema = yup.object().shape({
  left_nav_logo: logoSchemas,
  navList: navListSchema,
  campaignId: yup.string().required("Campaign ID is required"),
  uiType: yup.string().required("UI Type is required"),
  nav_right_logo: logoSchemaRight,
  seo_title: yup.string(),
  seo_description: yup.string(),
  seo_keywords: yup.string(),
  share_image: logoSchemaSEO,
  share_title: yup.string(),
  share_description: yup.string(),
  campaign_name: yup.string().required(""),
  campaign_type: yup.string().required("Campaign Type is required"),
  seoDone: yup.boolean(),
  favicon: logoSchemaSEO,
  pay_method: yup.string(),
});

const UpdateHeader = () => {
  const dataHeader = useSelector((state) => state.addCampaignReducer.dataAll);
  const [previousLeftLogo] = useState(
    dataHeader?.left_nav_logo?.image
  );

  const [isLoading, setIsLoading] = useState(false);

  const [previousRightLogo] = useState(
    dataHeader?.nav_right_logo?.image
  );

  // for images
  const [imageLinks, setImageLinks] = useState({
    left_nav_logo: "",
    nav_right_logo: "",
    share_image: "",
    campaign_type: "",
    campaign_name: ""
  });
  const [imageMessage, setImageMessage] = useState({
    left_nav_logo: true,
    nav_right_logo: true,
    share_image: true,
  });

  // collapse state
  const [columnVisibility, setColumnVisibility] = useState({
    leftNavLogo: false,
    rightNavLogo: false,
    navLists: false,
    seoData: false,
  });

  const toggleColumn = (columnName) => {
    setColumnVisibility({
      ...columnVisibility,
      [columnName]: !columnVisibility[columnName],
    });
  };

  const [shareImg] = useState(dataHeader?.share_image);
  const [open, setOpen] = useState(false);



  const [deletedUrl] = useState([]);

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    formState: { errors },
    register,
    clearErrors,
    setError,
    setValue,
    watch,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),

    defaultValues: {
      left_nav_logo: { file: null, link: "", alt: "", target: "" },
      nav_right_logo: { file: null, link: "", alt: "", target: "" },
      uiType: "",
      campaignId: "",
      navList: [{ text: "", link: "", target: "", order: "" }],
      seo_title: "",
      seo_description: "",
      seo_keywords: "",
      share_title: "",
      share_description: "",
      share_image: "",
      deleteUrl: deletedUrl,
      campaign_name: "",
      campaign_type: "",
      seoDone: false,
      pay_method: "",
      favicon: ""
    },
  });


  console.log(errors, "errors")

  const { fields, append, remove } = useFieldArray({
    control,
    name: "navList",
  });

  const handleBack = () => {
    navigate("/view-campaign");
  };

  const user = localStorage.getItem("userID");

  const validateImage = (file) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = URL.createObjectURL(file);

      image.onload = () => {
        const width = image.width;
        const height = image.height;
        const size = file.size / 1024;
        if (size >= 50) {
          reject("Image size exceeds 50KB limit.");
        }
        if (width >= 401 || height >= 211) {
          reject("File size 50KB and Intrinsic size is 400*210px.");
        }
        resolve(true);
      };
      image.onerror = () => {
        reject("Invalid image file.");
      };
    });
  };
  const handleImage = async (logo, e) => {
    const file = e.target.files[0];
    const isImage = file && file.type.startsWith("image/");

    const handleError = (logo, message) => {
      clearErrors(`${logo}.file`);
      setError(`${logo}.file`, {
        type: "manual",
        message,
      });
    };
    const updateState = async (logo, formData) => {
      try {
        const res = await dispatch(updateImage(formData));
        const valueKey = logo === "left_nav_logo" || logo === "nav_right_logo" ? `${logo}.image` : logo;
        setValue(valueKey, res);
        if (logo === "share_image" || logo === "favicon") {
          setValue(`${logo}`, res);
        } else {
          setValue(`${logo}.file`, res);
        }
        watch(res)
      } catch (error) {
        console.error("Error updating image:", error);
      }
    };

    if (!["left_nav_logo", "nav_right_logo", "share_image", "favicon"].includes(logo)) return;

    if (!isImage) {
      handleError(logo, "Invalid file type. Please select a valid image.");
      return;
    }
    try {
      if (["left_nav_logo", "nav_right_logo"].includes(logo)) {
        await validateImage(file);
      }
      const formData = new FormData();
      formData.append("image", file);
      formData.append("deleted_by", user);

      const linkMap = {
        left_nav_logo: previousLeftLogo,
        nav_right_logo: previousRightLogo,
        share_image: shareImg,
      };
      formData.append("link", linkMap[logo]);

      await updateState(logo, formData);
    } catch (error) {
      Toastify({ data: "error", msg: error });
      handleError(logo, error);
    }
  };

  const onSubmit = async (data) => {

    const { file: left, ...newLeftLogo } = data?.left_nav_logo;
    data.left_nav_logo = newLeftLogo;

    const { file: right, ...newRightLogo } = data?.nav_right_logo || {};
    data.nav_right_logo = newRightLogo;
    // const { file: favicon, ...faviconNew } = data.favicon;
    // data.favicon = faviconNew.image;

    const hasNavList = data?.navList?.[0]?.link !== "" ? true : false;

    const navRight = !newRightLogo?.image ? false : true;

    const campaignType = !data?.campaign_type ? localStorage.getItem("campaign_type") : data?.campaign_type

    const { navList, nav_right_logo, ...newData } = data;

    const newCreation = {
      ...newData,
      ...(hasNavList ? { navList: data?.navList } : { navList: null }),
      ...(navRight ? { nav_right_logo: newRightLogo } : { nav_right_logo: null }),
      updated_by: user,
      left_nav_logo: newLeftLogo,
      campaign_type: campaignType,
      // created_by:dataHeader?.created_by ? dataHeader?.created_by : user,
    };

    setIsLoading(true);
    const result = await dispatch(updateHeader(newCreation));

    if (result?.success === true) {
      setTimeout(() => {
        setIsLoading(false);
        handleBack();
      }, 1000);
    } else if (!result?.success) {
      //if something went wrong then go back to the view page
      handleBack();
    }
  };


  useEffect(() => {
    if (dataHeader) {
      setValue("left_nav_logo.file", dataHeader?.left_nav_logo?.image);
      setValue("left_nav_logo", dataHeader?.left_nav_logo);
      setValue("navList", dataHeader?.nav_lists);
      setValue("nav_right_logo.file", dataHeader?.nav_right_logo?.image);
      setValue("nav_right_logo", dataHeader?.nav_right_logo);
      setValue("campaignId", dataHeader?.campaign_Id);
      setValue("uiType", dataHeader?.ui_type);
      setValue("seo_title", dataHeader?.seo_title);
      setValue("seo_description", dataHeader?.seo_description);
      setValue("seo_keywords", dataHeader?.seo_keywords);
      setValue("share_image", dataHeader?.share_image);
      setValue("share_title", dataHeader?.share_title);
      setValue("share_description", dataHeader?.share_description);
      setValue("campaign_name", dataHeader?.campaign_name)
      setValue("campaign_type", dataHeader?.campaign_type)
      setValue("seoDone", dataHeader?.seoDone);
      setValue("favicon", dataHeader?.favicon);
      setValue("pay_method", dataHeader?.pay_method);

      localStorage.setItem("uiType", dataHeader?.ui_type);
      localStorage.setItem("campaignId", dataHeader?.campaign_Id);
      localStorage.setItem("campaign_name", dataHeader?.campaign_name);
      localStorage.setItem("campaign_type", dataHeader?.campaign_type);
    }
  }, [dataHeader, setValue]);




  const handleUrlChanges = (logo, e) => {
    const urlValue = e;
    if (logo === "left_nav_logo" || logo === "nav_right_logo") {
      clearErrors(`${logo}.file`);
      setValue(`${logo}.image`, urlValue);
      setValue(`${logo}.file`, urlValue);
    } else if (logo === "share_image" || logo === "favicon") {
      clearErrors(`${logo}.file`);
      setValue(`${logo}`, urlValue);
    }
    setOpen(!open)
  };

  const GetImage = (key) => {
    localStorage.setItem("key", key)
    setOpen(true);
  }
  const handleClose = () => {
    setOpen(!open)
  }


  return (
    <Paper elevation={3} sx={{ width: "98%" }}>
      <Box
        sx={{
          padding: "2rem",
        }}
      >
        <div className="">
          <form onSubmit={handleSubmit(onSubmit)}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              className="text-center fw-bold mb-3 border-bottom border-2 border-info pb-1"
              style={{ fontSize: "20px", color: "rgba(0, 165, 162, 0.9)" }}
            >
              Update Your Header Section
            </motion.div>
            <Row>
              <Col lg={6}>
                <div className="text-success text-bold text-center mb-2 buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('leftNavLogo')}>
                  Update Left Nav Logo <StarRateIcon />  {columnVisibility.leftNavLogo ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div className="column " style={{ display: columnVisibility.leftNavLogo ? 'block' : 'none' }}>
                  <div className="d-flex justify-content-around">
                    <Button
                      variant="contained"
                      component="label"
                      {...register('left_nav_logo.file')}
                      onClick={() => clearErrors('left_nav_logo.url')}
                    >
                      Upload Banner
                      <input
                        type="file"
                        {...register('left_nav_logo.file')}
                        hidden
                        onChange={(e) => handleImage("left_nav_logo", e)}
                        className={`file_button mb-1 ${errors.left_nav_logo && errors?.left_nav_logo?.file ? "error" : ""}`}
                      />
                    </Button>
                    {!watch(`left_nav_logo`)?.image ? <Button variant="contained" component="label" onClick={() => GetImage("left_nav_logo")} >Use Images </Button> : ""}
                    <div>
                      {/* {watch(`left_nav_logo`)?.image && (
                        <>
                        <img
                          src={watch(`left_nav_logo`)?.image}
                          alt=""
                          width={90}
                          className="rounded"
                        />
                        <CloseIcon style={{fontSize:"14px",marginBottom:"10px",borderRadius:"10px",background:"red",color:"white",cursor:"pointer"}} onClick={()=>handleDeleteImage(`left_nav_logo`)}/>
                        </>
                      )} */}
                      <ImageWithDeleteButton logoName={`left_nav_logo.image`} watch={watch} setValue={setValue} />
                    </div>

                  </div>
                  {imageMessage?.left_nav_logo && <p className="text-center mt-2 mb-0 text-secondary" style={{ fontSize: "10px" }}>File size 50KB and Intrinsic size is 400*150px.</p>}
                  <Controller
                    name={`left_nav_logo.link`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        required
                        {...field}
                        // id="outlined-required"
                        label="Left Logo Link"
                        className={`w-100 mt-3 ${errors.left_nav_logo && errors?.left_nav_logo.link
                          ? "error"
                          : ""
                          }`}
                      />
                    )}
                  />
                  <div className="d-flex gap-3">
                    <Controller
                      name={`left_nav_logo.alt`}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          required
                          {...field}
                          // id="outlined-required"
                          label="Left Logo ALT"
                          className={`w-100 mt-3 ${errors.left_nav_logo && errors?.left_nav_logo.alt
                            ? "error"
                            : ""
                            }`}
                        />
                      )}
                    />
                    <Controller
                      name={`left_nav_logo.target`}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          required
                          {...field}
                          // id="outlined-required"
                          label="Left Logo Target"
                          select
                          className={`w-100 mt-3 ${errors.left_nav_logo && errors?.left_nav_logo.target
                            ? "error"
                            : ""
                            }`}
                        >
                          <MenuItem value="_self">_self</MenuItem>
                          <MenuItem value="_blank">_blank</MenuItem>
                        </TextField>
                      )}
                    />
                  </div>
                </div>
                <hr />
              </Col>
              <Col lg={6}>
                <div className="text-success text-bold text-center mb-2 buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('rightNavLogo')}>
                  Update Right Nav Logo {columnVisibility.rightNavLogo ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div className="column " style={{ display: columnVisibility.rightNavLogo ? 'block' : 'none' }}>
                  <div className="d-flex justify-content-around">
                    <div >
                      <Button
                        variant="contained"
                        component="label"
                        {...register('nav_right_logo.file')}
                        onClick={() => clearErrors('nav_right_logo.url')}
                      >
                        Upload Banner
                        <input
                          type="file"
                          {...register('nav_right_logo.file')}
                          hidden
                          onChange={(e) => handleImage("nav_right_logo", e)}
                          className={`file_button mb-1 ${errors.nav_right_logo && errors?.nav_right_logo?.file ? "error" : ""}`}
                        />
                      </Button>
                    </div>
                    {!watch(`nav_right_logo`)?.image ? <Button variant="contained" component="label" onClick={() => GetImage("nav_right_logo")} >Use Images </Button> : ""}
                    <ImageWithDeleteButton logoName={`nav_right_logo.image`} watch={watch} setValue={setValue} />
                  </div>
                  {imageMessage?.nav_right_logo && <p className="text-center mt-2 mb-0 text-secondary" style={{ fontSize: "10px" }}>File size 50KB and Intrinsic size is 400*150px.</p>}
                  <Controller
                    name={`nav_right_logo.link`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        id="outlined-required"
                        label="Right Logo Link"
                        defaultValue=""
                        className="w-100 mt-3"
                      />
                    )}
                  />
                  <div className="d-flex gap-3">
                    <Controller
                      name={`nav_right_logo.alt`}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          id="outlined-required"
                          label="Right Logo ALT"
                          defaultValue=""
                          className="w-100 mt-3"
                        />
                      )}
                    />
                    <Controller
                      name={`nav_right_logo.target`}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          id="outlined-required"
                          select
                          label="Right Logo Target"
                          defaultValue=""
                          className="w-100 mt-3"
                        >
                          <MenuItem value="_self">_self</MenuItem>
                          <MenuItem value="_blank">_blank</MenuItem>
                        </TextField>
                      )}
                    />
                  </div>
                </div>
                <hr />
              </Col>
            </Row>

            <Row>
              <Col lg={6}>
                <div className="text-success text-bold text-center mt-3 buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('navLists')}>
                  Update Navigation Lists {columnVisibility.navLists ? <span><ExpandLessIcon /></span> : <span><ExpandMoreIcon /></span>}
                </div>
                <div className="mt-4" style={{ display: columnVisibility.navLists ? 'block' : 'none' }}>
                  {fields.map((item, index) => (
                    <div key={item.id} className="form-row  rounded-2 ">
                      <div className="column">
                        <Controller
                          name={`navList[${index}].text`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Text"
                              className={`form-control mb-3 ${errors.navList && errors?.navList[index]?.text
                                ? "error"
                                : ""
                                }`}
                            />
                          )}
                        />
                      </div>
                      <div className="column">
                        <Controller
                          name={`navList[${index}].link`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Link"
                              className={`form-control mb-3 ${errors.navList && errors?.navList[index]?.link
                                ? "error"
                                : ""
                                }`}
                            />
                          )}
                        />
                      </div>
                      <div className="d-flex gap-3 ">
                        <Controller
                          name={`navList[${index}].target`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              select
                              label="Enter Target"
                              className={`form-control mb-3 ${errors?.navList && errors?.navList[index]?.target
                                ? "error"
                                : ""
                                }`}
                            >
                              <MenuItem value="_self">_self</MenuItem>
                              <MenuItem value="_blank">_blank</MenuItem>
                            </TextField>
                          )}
                        />
                        <Controller
                          name={`navList[${index}].order`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Order"
                              select
                              className={`form-control mb-3 ${errors?.navList && errors?.navList[index]?.order
                                ? "error"
                                : ""
                                }`}
                            >
                              {[...Array(15)?.keys()].map((number) => (
                                <MenuItem
                                  key={number + 1}
                                  value={(number + 1).toString()}
                                >
                                  {number + 1}
                                </MenuItem>
                              ))}
                            </TextField>
                          )}
                        />
                      </div>
                      <div className="column d-flex justify-content-end">
                        {fields.length > 0 &&
                          <Tooltip title="Delete" arrow>
                            <DeleteIcon onClick={() => remove(index)} style={{ color: "red", cursor: "pointer" }} />
                          </Tooltip>
                        }
                      </div>
                    </div>
                  ))}
                  <Grid className="d-flex justify-content-between">
                    <Tooltip title="Add" arrow>
                      <Button
                        className="button "
                        variant="outlined"
                        disableElevation
                        startIcon={<Add />}
                        onClick={() =>
                          append({ text: "", link: "", target: "", order: "" })
                        }
                      >
                        Add
                      </Button>
                    </Tooltip>
                  </Grid>
                </div>
                <hr />
              </Col>
              <Col lg={6}>
                <div className="text-success text-center mt-3 mb-3 buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('seoData')}>
                  Update SEO Data   {columnVisibility.seoData ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                </div>
                <div className="mt-1" style={{ display: columnVisibility.seoData ? 'block' : 'none' }}>

                  <div className="column">
                    <Controller
                      name={`seo_title`}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          label="Enter SEO Title"
                          {...field}
                          id="outlined-required"
                          className={`w-100 mb-2 ${errors?.seo_title ? "error" : ""
                            }`}
                        />
                      )}
                    />
                  </div>
                  <div className="column">
                    <Controller
                      name={`seo_description`}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          label="Enter SEO Discription"
                          {...field}
                          id="outlined-required"
                          className={`w-100 mb-2 ${errors?.seo_description ? "error" : ""
                            }`}
                        />
                      )}
                    />
                  </div>
                  <div className="column">
                    <Controller
                      name={`seo_keywords`}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          label="Enter SEO Keywords"
                          {...field}
                          id="outlined-required"
                          className={`w-100 mb-2 ${errors?.seo_keywords ? "error" : ""
                            }`}
                        />
                      )}
                    />
                  </div>
                  <div className="column ">
                    <div className="">
                      <div className="text-success">Share Images</div>
                    </div>
                    <div className="d-flex justify-content-around mt-2 mb-2">
                      <Button
                        variant="contained"
                        component="label"
                        {...register('share_image.file')}
                        onClick={() => clearErrors('share_image.url')}
                      >
                        Upload File
                        <input
                          type="file"
                          {...register('share_image.file')}
                          hidden
                          onChange={(e) => handleImage("share_image", e)}
                          className={`file_button ${errors.share_image && errors?.share_image?.file ? "error" : ""}`}
                        />
                      </Button>
                      {!watch(`share_image`) ? <Button variant="contained" component="label" onClick={() => GetImage("share_image")} >Use Images </Button> : ""}
                      <div className="">
                        <ImageWithDeleteButton logoName={`share_image`} watch={watch} setValue={setValue} />
                      </div>
                    </div>
                    <div className="d-flex justify-content-around mb-3">
                      {!watch(`share_image`) && <p className="text-center mt-2 mb-0 text-secondary" style={{ fontSize: "10px" }}>File size 50KB and Intrinsic size is 400*150px.</p>}
                    </div>
                  </div>
                  <div className="column mb-3">
                    <div className="text-success text-center">Favicon Images</div>
                    <div className="d-flex justify-content-around">
                      <Button
                        variant="contained"
                        component="label"
                        {...register('favicon.file')}
                      >
                        Favicon Image
                        <input
                          type="file"
                          {...register('favicon.file')}
                          hidden
                          onChange={(e) => handleImage("favicon", e)}
                          className={`file_button mb-1 ${errors.favicon && errors?.favicon?.file ? "error" : ""}`}
                        />
                      </Button>
                      <ImageWithDeleteButton logoName={`favicon`} watch={watch} setValue={setValue} />
                      {/* {console.log(watch(`favicon`), "hello")} */}
                      {!watch(`favicon`) ? <Button variant="contained" component="label" onClick={() => GetImage("favicon")} >Use Images </Button> : ""}
                    </div>
                    <div className="text-center">
                      {!watch(`favicon`) && <p className="text-center mt-2 mb-0 text-secondary" style={{ fontSize: "10px" }}>File size 50KB and Intrinsic size is 400*150px.</p>}
                    </div>
                  </div>
                  <div className="column mt-2">
                    <Controller
                      name={`share_title`}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          label="Enter Share Title"
                          {...field}
                          id="outlined-required"
                          className={`w-100 mb-2 ${errors?.share_title ? "error" : ""
                            }`}
                        />
                      )}
                    />
                  </div>
                  <div className="column mt-2">
                    <Controller
                      name={`share_description`}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          label="Enter Share Description"
                          {...field}
                          id="outlined-required"
                          className={`w-100 mb-2 ${errors?.share_description ? "error" : ""
                            }`}
                        />
                      )}
                    />
                  </div>
                  <div className="column mb-2">
                    <Controller
                      name="seoDone"
                      control={control}
                      render={({ field }) => (
                        <FormControlLabel
                          control={<Checkbox {...field} checked={field?.value} />}
                          label="Seo Data Done"
                        />
                      )}
                    />
                  </div>
                </div>
                <hr />

              </Col>
            </Row>


            <Row>
              <Col>
                <div className="mt-4">
                  <Controller
                    name="pay_method" // Field name
                    control={control} // React Hook Form control object
                    defaultValue="" // Set default value here if needed
                    render={({ field }) => (
                      <TextField
                        select
                        label="Select Your Payment Method *"
                        {...field} // Spread the field object from Controller
                        className={`w-100 mt-4  ${errors.pay_method ? "error" : ""}`}
                      >
                        <MenuItem value="razorPay">Razor Pay</MenuItem>
                        <MenuItem value="payU">PayU</MenuItem>
                      </TextField>
                    )}
                  />
                </div>
              </Col>

            </Row>
            <hr />

            <Row>
              <Col>

                <Controller
                  name="campaign_type" // Field name
                  control={control} // React Hook Form control object
                  defaultValue="" // Set default value here if needed
                  render={({ field }) => (
                    <TextField
                      select
                      label="Please Update Campaign Type"
                      {...field} // Spread the field object from Controller
                      className={`w-100 mt-2 ${errors && errors.campaign_type ? "error" : ""}`}
                    >
                      <MenuItem value="Internal">Internal</MenuItem>
                      <MenuItem value="External">External</MenuItem>
                    </TextField>
                  )}
                />

                {errors.campaign_type && <div style={{ color: "red", marginLeft: "10px" }}>{errors.campaign_type.message}</div>}
                <hr />
              </Col>
              <Col>

                <div className="column mt-2">
                  <Controller
                    name={`campaign_name`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        label="Enter campaign Name"
                        {...field}
                        id="outlined-required"
                        className={`w-100 mb-2 ${errors?.campaign_name ? "error" : ""
                          }`}
                      />
                    )}
                  />
                </div>
                <hr />
              </Col>
            </Row>
            <Grid className="d-flex justify-content-between">
              <Toolbar className="p-0">
                <Button
                  // color="inherit"
                  className="button "
                  variant="contained"
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                >
                  Back
                </Button>
              </Toolbar>
              {isLoading ? (
                <Toolbar className="p-0">
                  <Button
                    className="button "
                    variant="contained"
                    disableElevation
                  >
                    Loading...
                    <CircularProgress color="success" size="1.7rem" />
                  </Button>
                </Toolbar>
              ) : (
                <Toolbar className="p-0">
                  <Button
                    className="button "
                    variant="contained"
                    disableElevation
                    // endIcon={<NavigateNextIcon />}
                    type="submit"
                  >
                    Update
                  </Button>
                </Toolbar>
              )}
              {/* <div>    <SpeedDialTooltipOpen /></div> */}
            </Grid>
          </form>
        </div>
      </Box>
      <ImageModal open={open} handleClose={handleClose} handleUrlChanges={handleUrlChanges} />
    </Paper>
  );
};

export default UpdateHeader;
